import { formatSecondsToHumanReadable } from '@helpers';
import { getFullName } from '@utils/helpers';
import { Modal } from 'antd';
import moment from 'moment';

type VideoCallModalProps = {
  open: boolean;
  onClose: () => void;
  videoCallRecording: VideoCallRecording;
};

export const VideoCallRecordingModal = ({
  open,
  onClose,
  videoCallRecording,
}: VideoCallModalProps) => {
  return (
    <Modal
      open={open}
      onOk={onClose}
      title="Video Call Recording"
      footer={null}
      width={800}
      onCancel={onClose}
    >
      <video controls height="auto" width="100%" src={videoCallRecording.url} />
      <p>
        <b>Course:</b> {videoCallRecording.videoCall?.course?.name}
      </p>
      <p>
        <b>Student:</b>{' '}
        {videoCallRecording.videoCall?.student
          ? getFullName(videoCallRecording.videoCall?.student)
          : '-'}
      </p>
      <p>
        <b>Instructor:</b>{' '}
        {videoCallRecording.videoCall?.instructor
          ? getFullName(videoCallRecording.videoCall?.instructor)
          : '-'}
      </p>
      <p>
        <b>Started at:</b>{' '}
        {videoCallRecording.videoCall?.startedAt
          ? moment(videoCallRecording.videoCall?.startedAt).format('LLL')
          : '-'}
      </p>
      <p>
        <b>Ended at:</b>{' '}
        {videoCallRecording.videoCall?.endeddAt
          ? moment(videoCallRecording.videoCall?.endeddAt).format('LLL')
          : '-'}
      </p>
      <p>
        <b>Duration:</b> {formatSecondsToHumanReadable(videoCallRecording.duration)}
      </p>
    </Modal>
  );
};
